import { render, staticRenderFns } from "./ChatbotPlayer.vue?vue&type=template&id=ca36c79c&scoped=true"
import script from "./ChatbotPlayer.vue?vue&type=script&lang=js"
export * from "./ChatbotPlayer.vue?vue&type=script&lang=js"
import style0 from "./ChatbotPlayer.vue?vue&type=style&index=0&id=ca36c79c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca36c79c",
  null
  
)

export default component.exports